import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { errorTextsPath } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
const unvoidLoader = (invoiceId)=>"unvoidInvoice-".concat(invoiceId);
export function useUnvoidInvoice() {
    const { api } = useStoreActions();
    const { startLoader, stopLoader, showErrorToast } = useOverlayContext();
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    return {
        async startUnvoidInvoice (invoice) {
            startLoader(unvoidLoader(invoice.id));
            const result = await handleRequest(api.invoice.unvoid(invoice.id));
            if (result.success) {
            // Here we wait for a pusher event to stop the loader and update the invoice.
            } else {
                showErrorToast(result.error.unvoidInvoiceErrorText(invoice, errorTexts), 'fpi-unvoid-invoice-error');
                stopLoader(unvoidLoader(invoice.id));
            }
        },
        async finishUnvoidInvoice (invoiceId) {
            stopLoader(unvoidLoader(invoiceId));
        }
    };
}
